import { faTerminal } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function lpCmdBus() {
    return (
        <div data-cy="history-lpCmdBus">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.lpCmdBus" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faTerminal} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
